import { css } from "@emotion/css";
import { findUISchema } from "@jsonforms/core";
import { ItemProps } from "../types";
import { JsonFormsDispatch } from "@jsonforms/react";
import { Divider, ExpandableCard } from "@certn/cascadia-react";
import { GhostButton, PrimaryButton, Stack } from "@certn/cascadia";
import { FormContext, useSlottedContext } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { useContext, useMemo } from "react";
import { CascadiaJsonFormContext } from "../../../../CascadiaJsonFormContext";
import { getHasItemEditToggle, getItemName } from "../../utils";
import { useItemHeadingText } from "../ItemHeading/utils";

export function CardItemNew(props: ItemProps) {
  const {
    index,
    label,
    schema,
    uischema,
    uischema: { options = {} },
    uischemas,
    path,
    parentPath,
    rootSchema,
    removeItems,
    minItems,
  } = props;
  const { onSubmit } = useSlottedContext(FormContext) as any;
  const { isSummary: globalIsSummary } = useContext(CascadiaJsonFormContext);
  const { t } = useTranslation();
  const headingText = useItemHeadingText(
    index,
    label,
    minItems,
    uischema,
    path
  );
  const itemName = getItemName(uischema, label, t("item"));
  const itemSchema = findUISchema(
    uischemas || [],
    schema,
    uischema.scope,
    path,
    undefined,
    uischema,
    rootSchema
  );
  const showSaveButton = useMemo(
    () => getHasItemEditToggle(uischema, globalIsSummary),
    [uischema, globalIsSummary]
  );

  return (
    <ExpandableCard
      title={headingText || ""}
      cardStyles={options.newCardStyles}
      expanded={true}
      expandable={false}
    >
      <div className={styles.cardContent}>
        <Stack gap="space-4">
          <JsonFormsDispatch
            schema={schema}
            uischema={itemSchema}
            path={path}
          />

          <Divider />
          <Stack
            orientation="horizontal"
            justify={showSaveButton ? "space-between" : "end"}
            gap="space-2"
          >
            {showSaveButton && (
              <PrimaryButton onPress={onSubmit} type="submit">
                {options.saveItemLabel ?? t("Save {{itemName}}", { itemName })}
              </PrimaryButton>
            )}
            <GhostButton
              onPress={removeItems?.(parentPath, [index])}
              leftIcon="delete"
              isDisabled={!props.enabled}
            >
              {t("Delete")}
            </GhostButton>
          </Stack>
        </Stack>
      </div>
    </ExpandableCard>
  );
}

const styles = {
  cardContent: css({
    paddingLeft: "var(--space-4)",
    paddingRight: "var(--space-4)",
  }),
};
